<template>
    <div>
        <div id="customCodeInjectorBlock" :data-condition="userAuthBool" v-html="htmlCodeParsed"></div>
    </div>
</template>

<script>
export default {
    props:{
        primaryColor:{
            type:String,
            default:""
        },
        htmlCode:{
            type:String,
            default:""
        },
        cssCode:{
            type:String,
            default:""
        },
        jsCode:{
            type:String,
            default:""
        },
        userAuth:{
            type:String,
            default:""
        },
        userName:{
            type:String,
            default:""
        },
        userEmail:{
            type:String,
            default:""
        },
    },
    computed:{
        userAuthBool(){
            return this.userAuth === 'True'
        },
        htmlCodeParsed(){
            return this.htmlCode.replace(/{{userAuth}}/g, this.userAuth)
        }
    },
    created(){
        
        let jsParsed = document.createTextNode(this.jsCode)
        let customJS = document.createElement('script');
        customJS.setAttribute('type', 'text/javascript');
        customJS.setAttribute('language', 'javascript');
        customJS.appendChild(jsParsed)
        document.head.appendChild(customJS)

        let styleEl = document.createElement('style');
        styleEl.appendChild(document.createTextNode(this.cssCode))
        document.head.appendChild(styleEl)
    }   
}
</script>